import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const server = process.env.NODE_ENV;
const hammData = window.hammurabiReactTools || {};
const view = window.hammurabiView || {};

if (server === 'development') {
	ReactDOM.render(<App dataConfig={hammData} view={view} />, document.getElementById('root'));
} else {
	const reactAppData = window.hammurabiReactTools || {};
	const { appSelector } = reactAppData;
	const appAnchorElement = document.querySelector(appSelector);
	if (appAnchorElement) {
		ReactDOM.render(<App dataConfig={hammData} view={view} />, appAnchorElement);
	}
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
